import { render, staticRenderFns } from "./AdminDemandOverview.vue?vue&type=template&id=37893744&"
import script from "./AdminDemandOverview.vue?vue&type=script&lang=js&"
export * from "./AdminDemandOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports